import angular from 'angular';
import ngMessages from 'angular-messages';
import moment from 'moment';
import ngTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
import TkrSpaCommon from '../../../common/tkr-spa';
import TkrAppConfig from '../../../common/TkrAppConfig';
import { TkrPersonService } from '../../../common/tkr-commonservices';
import { IbanService, IbanValidator } from '../../../common/ma-iban';
import { SmartFloat, SmartInteger } from '../../../common/ma-smartfloat-1.0';
import TkrPpCommon from '../../../pp/common/0-pp-common-module';
import TkrPpResources from '../../../pp/prcportal-resource-modules';
import uiValidate from 'angular-ui-validate';
import { configureTranslateProvider } from '../../../pp/translation-helpers';
const subsidy_application_app = angular.module('ng-tkr-app-sastamala2017', [
    TkrSpaCommon,
    ngMessages,
    ngTranslate,
    TkrPersonService,
    IbanValidator,
    IbanService,
    SmartFloat,
    SmartInteger,
    uiValidate,
    TkrPpResources,
    TkrAppConfig,
    TkrPpCommon,
])
    .config(config)
    .config(configureTranslateProvider);
export default subsidy_application_app.name;
config.$inject = ['$stateProvider', '$urlRouterProvider'];
function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/err');
    $stateProvider
        .state('err', {
        url: '/err',
        template: '<p class="h4 text-danger">Sisäinen virhe. Ota yhteyttä helpdesk@matriset.fi.</p>'
    })
        .state('root', {
        url: '',
        template: '',
        controller: 'AppRedirCtrl',
        controllerAs: 'vm'
    })
        .state('lomake', {
        url: '/:applicationId',
        template: require('./app.tpl.html'),
        controller: 'SubsidyApplicationController',
        controllerAs: 'vm',
        resolve: {
            app: ['PortalSubsidyAppService', '$stateParams', function (PortalSubsidyAppService, $stateParams) {
                    return PortalSubsidyAppService.get({ appId: $stateParams.applicationId }).$promise;
                }],
            appPeriod: ['PortalAppPeriodService', 'app', function (PortalAppPeriodService, app) {
                    return PortalAppPeriodService.get({ periodId: app.applicationPeriodId }).$promise;
                }]
        }
    })
        .state('jatetty', {
        url: '/:applicationId/jatetty',
        template: require('./app-submitted.tpl.html'),
        controller: 'AppSubmittedController',
        controllerAs: 'vm'
    });
}
subsidy_application_app.directive('validateKpitoMenot', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attributes, ngModel) {
            ngModel.$validators.validateKpitoMenot = function (modelValue) {
                return modelValue == 'ei';
            };
        }
    };
});
subsidy_application_app.controller('SubsidyApplicationController', SubsidyApplicationController);
SubsidyApplicationController.$inject = [
    '$scope',
    'app',
    'appPeriod',
    'TkrPersonService',
    'IbanService',
    '$state',
    '$stateParams'
];
function SubsidyApplicationController($scope, app, appPeriod, TkrPersonService, IbanService, $state, $stateParams) {
    var vm = this;
    vm.app = app;
    vm.vuosi = appPeriod.td.wnum.vuosi;
    vm.edvuosi = vm.vuosi - 1;
    vm.loppuAika = moment(appPeriod.end).local().format('D.M.YYYY HH:mm');
    vm.personRoles = TkrPersonService.personRoles;
    vm.chairmanRoles = TkrPersonService.chairmanRoles;
    vm.preprocessApp = function (data) {
        if (!data.chairman) {
            data.chairman = {};
        }
        if (!data.contactPerson) {
            data.contactPerson = {};
        }
        if (!data.td) {
            data.td = {};
        }
        if (!data.td.num) {
            data.td.num = {};
        }
        if (!data.td.wnum) {
            data.td.wnum = {};
        }
        if (!data.td.bools) {
            data.td.bools = {};
        }
    };
    vm.preprocessApp(vm.app);
    vm.contactIsChairman = function () {
        return TkrPersonService.isValidChairmanRole(vm.app.contactPerson.role);
    };
    vm.isSeparateChairmanRequired = function () {
        return !vm.contactIsChairman();
    };
    vm.postprocessApp = function (data) {
        if (!vm.isSeparateChairmanRequired()) {
            data.chairman = data.contactPerson;
        }
        if (data.td.bools.isEligible) {
            data.established = true;
        }
        if (data.bypassRoad && data.td.wnum.lapiKulkuPituus == data.sameTownLength) {
            data.subsidiedLength = 0;
        }
    };
    vm.save = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'SUBMITTED';
        vm.app.$save().then(function (data) {
            $state.go('jatetty', { applicationId: data.id });
        });
    };
}
